import React from 'react';
import { Button } from 'antd';
import styles from "../list/layout.module.less";
import checkPic from "../../../inc/check.png"
import history from "../../../libs/history";
import store from "../../goods/store";


export default class extends React.Component {
  constructor(props) {
    super(props);

    const query = this.props.location.search // '?s=1&f=7'
    const arr = query.split('=') // ['?s=', 'f=7']
    this.id = arr[1]

  }
  render() {
    return (
      <div className={styles.cart}>
        <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
          <div className="step prev">我的购物车</div>
          <div className="step cur">提交求购单</div>
        </div>

        <div className="resultShow">
          <div className="resultBody">
            <img className="img" src={checkPic} alt=""/>
            <div className="t1">恭喜！您的求购单已提交！</div>
            <div className="t2">您的求购单号为：<span>{this.id}</span></div>

            <div className="t3">
              您的求购单已经收到。<br/>
              我们将立即处理您的求购单以锁定国内现货。
            </div>
          </div>
          <div className="resultFoot">
            <Button type="primary" size="large" onClick={()=>{history.go(-1)}}>继续求购</Button>
            {/*<Button type="primary" size="large" onClick={()=>{history.push('/user/purchase')}}>去用户中心</Button>*/}
            <Button type="primary" size="large" onClick={()=>{history.push('/home')}}>去首页</Button>
          </div>
        </div>


      </div>
    )
  }
}
